<template lang="pug">
  l-geoJson(
    v-if="state.instituciones"
    :geojson="geoJson"
    :options="options"
  )
</template>

<script>
import L from 'leaflet'
import { mapActions, mapGetters } from 'vuex'
import markerMixin from '@/mixins/marker-for-instituciones.js'

export default {
  mixins: [ markerMixin ],
  methods: {
    ...mapActions([ 'setCentroMunicipal' ]),
    showDetalle (centroMunicipal) {
      this.$emit('show-detail', { centroMunicipal })
    },
    buildPopup (item) {
      return `
          <h4>${item['centros_municipales']}</h4>
        `
    },
    buildIcon (item) {
      return L.divIcon({
        className: `makerBlueIcon centros_municipales`,
        html: `
          <div>
            <div class="ap-pin Centro-municipal">
              <span class="ap-Centro-municipal sub-icon"></span>
            </div>
          </div>
        `,
        iconSize: [45, 45]
      })
    }
  },
  computed: {
    ...mapGetters({ geoJson: 'centrosMunicipales', state: 'interfaceState', markerData: 'centroMunicipal' })
  }
}
</script>

<style lang="stylus">
@import '~@/styles/variables'
@import '~@/styles/instituciones/variables'

.makerBlueIcon
  .ap-pin.Centro-municipal
    color: $centroMunicipalColor
  &.active
    .ap-pin.Centro-municipal
      .ap-Centro-municipal
        font-size: 35px
        top: 11px
        left: 20.5px
</style>
